<template>
  <div class="login-page">
    <div class="login-bg">
      <!-- <img class="login-main" src="../assets/login-main.png" alt /> -->
      <div class="login-icon-box">
        <img class="logo-icon icon-1" src="../assets/title_icon.png" alt />
        <img class="logo-icon icon-2" src="../assets/circle1.png" alt />
        <img class="logo-icon icon-3" src="../assets/circle2.png" alt />
        <img class="logo-icon icon-4" src="../assets/circle3.png" alt />
        <img class="logo-icon icon-5" src="../assets/tetragonum1.png" alt />
        <img class="logo-icon icon-6" src="../assets/tetragonum2.png" alt />
        <img class="logo-icon icon-7" src="../assets/triangle1.png" alt />
        <img class="logo-icon icon-8" src="../assets/triangle2.png" alt />
      </div>
      <div class="oa-login">
        58员工请
        <a
          href="https://passport.58corp.com/login?service=https://survey.58corp.com/survey#/mine"
          class="oa-login-btn"
        >
          点此登录
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../utils/http";
import { MSG } from "../utils/utils";
let timer = null;
export default {
  name: "Login",
  data() {
    return {};
  },
  mounted() {
    this.login();
    timer = setInterval(this.updateDom, 30);
  },
  destroyed() {
    timer && clearInterval(timer);
  },
  methods: {
    login() {
      window.pop_init({
        exchangeDomain: "passport.58.com",
        source: "58-wenjuan-pc",
        // path: "//wenjuan.58.com/#/home",
        path:"//wenjuan.58.com",//休眠期使用的path
        domain: "58.com",
        biz: "58",
        mobile: "",
        uname: "",
        loginMode: [0, 1, 2, 3],
        isLinkToRegister: true,
        clause: [
          {
            title: "58同城使用协议",
            href: "//wenjuan.58.com/survey/#/protocol?type=service",
          },
          {
            title: "隐私条款",
            href: "//wenjuan.58.com/survey/#/protocol?type=private",
          },
        ],
        logoHref:
          "http://img.58cdn.com.cn/git/teg-app-fe/wuba-questionnaire-outside/img/Logops.png",
        isJumpBind: true,
        callback: function () {
          window.location.href = `${window.location.origin}/#/upgrade`;
        },
      });
    },
    updateDom() {
      let totalHeight = document.body.offsetHeight || 0;
      let dom = document.querySelector(".pop_mask");
      if (dom && dom.offsetHeight) {
        let oaDom = document.querySelector(".oa-login");
        oaDom.style.top = (totalHeight + dom.offsetHeight+40) / 2 + "px";
      }
    },
  },
};
</script>

<style lang="scss">
html,
body {
  overflow: hidden;
}
.login-page {
  min-width: 1200px;
  width: 100%;
  height: 100%;
}
.login-bg {
  width: 100%;
  height: 100%;
  background-image: url(../assets/login-bg@2x.png);
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% 100%;
  overflow: hidden;
  min-width: 1200px;
}
.login-icon-box {
  position: fixed;
  display: inline-block;
  background: rgba(0, 0, 0, 0);
  transform: scale(0.7);
  left: 3%;
  top: 3%;
  .logo-icon {
    position: absolute;
  }
  .icon-1 {
    top: 314px;
    left: 260px;
    z-index: 10;
  }
  .icon-2 {
    top: 215px;
    left: 242px;
    animation: icon2 10s cubic-bezier(0, 0, 1, 1) infinite alternate forwards;
  }
  .icon-3 {
    left: 200px;
    top: 800px;
    animation: icon3 10s cubic-bezier(0, 0, 1, 1) infinite alternate forwards;
  }
  .icon-4 {
    left: 857px;
    top: 185px;
    animation: icon4 10s cubic-bezier(0, 0, 1, 1) infinite alternate forwards;
  }
  .icon-5 {
    left: 620px;
    top: 240px;
    animation: icon5 10s cubic-bezier(0, 0, 1, 1) infinite alternate forwards;
  }
  .icon-6 {
    left: 800px;
    top: 570px;
    animation: icon6 10s cubic-bezier(0, 0, 1, 1) infinite alternate forwards;
  }
  .icon-7 {
    left: 357px;
    top: 514px;
    animation: icon7 10s cubic-bezier(0, 0, 1, 1) infinite alternate forwards;
  }
  .icon-8 {
    left: 170px;
    top: 428px;
    animation: icon8 10s cubic-bezier(0, 0, 1, 1) infinite alternate forwards;
  }
}
.oa-login {
  position: absolute;
  top: 580px;
  color: #fff;
  z-index: 10000000;
  
  display: inline-block;
  width: 122px;
  margin-left: calc(75% - 60px) !important;
  .oa-login-btn {
    color: #ff552e;
    position: relative;
    left: -5px;
    cursor: pointer;
  }
}

@keyframes icon2 {
  50% {
    transform: translate(-20px, -20px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes icon3 {
  50% {
    transform: translate(-13px, 30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes icon4 {
  50% {
    transform: translate(0, -10px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes icon5 {
  50% {
    transform: translate(40px, 20px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes icon6 {
  50% {
    transform: rotateZ(130deg);
  }
  100% {
    transform: rotateZ(0);
  }
}
@keyframes icon7 {
  50% {
    transform: translateX(-50px) rotateZ(30deg);
  }
  100% {
    transform: translateX(0) rotateZ(0);
  }
}
@keyframes icon8 {
  50% {
    transform: rotateZ(90deg);
  }
  100% {
    transform: rotateZ(0);
  }
}

.popup_register .pop_head {
  box-sizing: content-box;
}

.popup_home,
.popup_register,
#pop_body {
  background: rgba(0, 0, 0, 0) !important;
}
.popup_home .pop_mask,
.popup_register .pop_mask,
#mask_body,
#new_mask_body {
  margin-left: 75% !important;
}
.popup_home .close,
.popup_register .close,
#close_icon {
  display: none !important;
}
.popup_home .item input,
.popup_register .item input,
.mask_body_item input {
  border: 1px solid #dddddd !important;
  border-radius: 2px !important;
  border-radius: 2px !important;
}
.popup_home .item .btn {
  color: #fff !important;
}
.appeal.appeal_mobile,
.appeal.appeal_account {
  visibility: hidden !important;
}

.popup_home .protocol,
.popup_register .protocol,
.mask_body_item .protocol {
  font-size: 12px !important;
  a {
    color: #333 !important;
  }
}

@media screen and(min-width: 1024px) {
  .login-icon-box {
    transform: scale(0.7);
  }
} /*>=1024的设备屏幕*/

@media screen and(min-width: 1100px) {
  .login-icon-box {
    transform: scale(0.7);
  }
} /*>=1100的设备屏幕*/
@media (min-width: 1280px) {
  .login-icon-box {
    transform: scale(0.7);
  }
} /*>=1280的设备屏幕*/

@media screen and(min-width: 1366px) {
  .login-icon-box {
    transform: scale(0.75);
    left: 5%;
    top: 5%;
  }
} /*>=1366的设备屏幕*/

@media screen and(min-width: 1440px) {
  .login-icon-box {
    transform: scale(0.8);
    left: 7%;
    top: 7%;
  }
} /*>=1440的设备屏幕*/

@media screen and(min-width: 1680px) {
  .login-icon-box {
    transform: scale(0.85);
    left: 10%;
    top: 10%;
  }
}

#mask_body,
#new_mask_body {
  top: 50% !important;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue